<template>

    <div class="d-header">

		</div>
</template>

<script>
  export default {
    data() {
      return {

      };
    },

    methods: {


    }

  }
</script>

<style>
	
</style>



// WEBPACK FOOTER //
// src/components/header.vue